import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { getSession } from '../../lib/auth';

export const RequireAuth = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const session = getSession();

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
};
